import type { OptionPoints } from '@gcv/shared';

/** Options are authored as one `;`-separated string; this is the list behind it. */
export const parseFieldOptions = (options?: string): string[] =>
  (options ?? '')
    .split(';')
    .map((option) => option.trim())
    .filter((option) => option.length > 0);

/**
 * Points for the options that currently exist, keyed by option label. Renaming or removing an
 * option drops its points, since the map is keyed by the label itself. Options without a point
 * value yet default to 0.
 */
export const syncOptionPoints = (options?: string, points?: OptionPoints): OptionPoints => {
  const synced: OptionPoints = {};

  parseFieldOptions(options).forEach((option) => {
    const existing = points?.[option];
    synced[option] = typeof existing === 'number' && !Number.isNaN(existing) ? existing : 0;
  });

  return synced;
};
